<!--Author: Michał Pawłowski-->
<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-sm-6 contact-form">
        <h2>Skontaktuj się z nami</h2>
        <form @submit.prevent="sendMail">
          <div class="form-group">
            <label for="name">Imię</label>
            <input
              type="text"
              id="name"
              v-model="name"
              placeholder="Wpisz swoje imię"
              class="form-control"
            />
          </div>
          <div class="form-group">
            <label for="email">Adres e-mail</label>
            <input
              type="text"
              id="email"
              v-model="email"
              placeholder="Wpisz swój adres e-mail"
              class="form-control"
            />
          </div>
          <div class="form-group">
            <label for="subject">Temat</label>
            <input
              type="text"
              id="subject"
              v-model="subject"
              placeholder="Wpisz temat"
              class="form-control"
            />
          </div>
          <div class="form-group">
            <label for="content">Treść</label>
            <textarea
              id="content"
              v-model="content"
              placeholder="Wpisz treść"
              class="form-control"
            ></textarea>
          </div>
          <button type="submit" class="btn btn-primary">Wyślij</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "ContactForm.vue",
  data: () => ({
    name: "",
    email: "",
    subject: "",
    content: "",
  }),
  methods: {
    validateForm() {
      if (!this.name || !this.email || !this.subject || !this.content) {
        return false;
      }
      // validate email
      const emailRegex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!emailRegex.test(this.email)) {
        return false;
      }
      return true;
    },
    sendMail() {
      if (!this.validateForm()) {
        alert("Data not valid");
      }

      const message = {
        from: this.email,
        to: "example@example.com",
        subject: this.subject,
        text: this.content,
      };
      alert("Sending a message: " + message.toString());
    },
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
};
</script>

<style scoped>
.form-control {
  width: 100%;
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.btn {
  margin-top: 10px;
}

.contact-form {
  background: #fff;
  padding: 20px;
  margin-top: 30px;
}
</style>
